<template>
  <v-app>
    <v-snackbar v-model="snackbar" vertical>
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container>
      <v-row class="pb-3 mb-3" style="border-bottom: 1px solid #EDEDED">
        <v-col class="col-12">
          <h2
            class="mx-2 text-center text-md-left font-weight-regular"
            style="color: var(--v-primary-base)"
          >
            <v-icon size="32" color="primary">date_range</v-icon>Agenda
          </h2>
        </v-col>
      </v-row>
      <v-row class="justify-space-between">
        <v-col class="col-12 col-md-5 col-lg-6 text-center">
          <div
            class="pa-3 mb-3 subheading"
            style="background: #02a554; color: #ffffff;"
          >Escolha os dias com horário de disponibilidade iguais.</div>
          <v-date-picker
            v-model="listDate"
            full-width
            locale="pt-br"
            multiple
            color="primary"
            :min="minDate"
          ></v-date-picker>
        </v-col>
        <v-col class="col-12 col-md-6 align-center">
          <div
            class="pa-3 mb-3 subheading text-sm-center"
            style="background: #02a554; color: #ffffff;"
          >Escolha os horários disponíveis nos dias selecionados.</div>
          <div>
            <v-row class="px-3">
              <v-col class="shrink pa-1 col-auto" v-for="(hour,index) in hours" :key="index">
                <v-checkbox
                  class="list__hours"
                  v-model="selected"
                  :value="hour.value"
                  :label="hour.description"
                ></v-checkbox>
              </v-col>
              <v-col class="col-12 text-center text-sm-right">
                <v-btn class="mr-4" large text @click="$router.go(-1)">CANCELAR</v-btn>
                <v-btn color="secondary" large @click="postSchedele" :loading="loader" :disabled="isDisabled">{{$t('pageCreateAgenda.btnSalvar')}}</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Axios from 'axios';
import moment from 'moment-timezone';
import { createSchedule } from '../../services/psychologists';

export default {
  data() {
    return {
      isDisabled: true,
      listDate: [],
      hours: [
        {
          value: '00:00',
          description: '00h-01h',
        },
        {
          value: '01:00',
          description: '01h-02h',
        },
        {
          value: '02:00',
          description: '02h-03h',
        },
        {
          value: '03:00',
          description: '03h-04h',
        },
        {
          value: '04:00',
          description: '04h-05h',
        },
        {
          value: '05:00',
          description: '05h-06h',
        },
        {
          value: '06:00',
          description: '06h-07h',
        },
        {
          value: '07:00',
          description: '07h-08h',
        },
        {
          value: '08:00',
          description: '08h-09h',
        },
        {
          value: '09:00',
          description: '09h-10h',
        },
        {
          value: '10:00',
          description: '10h-11h',
        },
        {
          value: '11:00',
          description: '11h-12h',
        },
        {
          value: '12:00',
          description: '12h-13h',
        },
        {
          value: '13:00',
          description: '13h-14h',
        },
        {
          value: '14:00',
          description: '14h-15h',
        },
        {
          value: '15:00',
          description: '15h-16h',
        },
        {
          value: '16:00',
          description: '16h-17h',
        },
        {
          value: '17:00',
          description: '17h-18h',
        },
        {
          value: '18:00',
          description: '18h-19h',
        },
        {
          value: '19:00',
          description: '19h-20h',
        },
        {
          value: '20:00',
          description: '20h-21h',
        },
        {
          value: '21:00',
          description: '21h-22h',
        },
        {
          value: '22:00',
          description: '22h-23h',
        },
        {
          value: '23:00',
          description: '23h-24h',
        },
      ],
      selected: [],
      cod: '',
      loader: false,
      snackbar: false,
      msg: '',
      time_zone_name: '',
    };
  },
  created() {
    this.getCod();
    const data_user = localStorage.getItem('user-data');
    this.time_zone_name = JSON.parse(data_user).time_zone_name;
  },
  watch: {
    selected(val) {
      if (val.length != 0 && this.listDate.length != 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    listDate(val) {
      if (val.length != 0 && this.selected.length != 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
  computed: {
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
  methods: {
    async postSchedele() {
      this.loader = true;
      const list = await this.creatListData();
      // return

      try {
        const { data, status } = await createSchedule(this.cod, list);

        if (status == 201) {
          this.msg = 'Cadastro realizado com sucesso!';
          this.snackbar = true;
          setTimeout(() => {
            this.$router.replace('/psicologo/schedule');
          }, 3000);
        }
      } catch (error) {
        if (error.response.data[0].includes('Horário já passado')) {
          this.msg = 'O horário que deseja cadastrar já passou, esolha um hário futuro.';
        } else if (error.response.data[0].includes('Data e horário')) {
          this.msg = 'Algum dos horários escolhido já foi cadastrado anteriormente!';
        } else {
          this.msg = 'Ocorreu um erro ao cadastrar a agenda, tente novamente mais tarde!';
        }
        this.snackbar = true;
      } finally {
        this.loader = false;
      }
    },

    getCod() {
      this.cod = localStorage.getItem('user-id');
    },

    creatListData() {
      const { listDate } = this;
      const data = [];
      for (const date of listDate) {
        for (const time of this.selected) {
          const item = {
            date,
            time: moment.tz(`${date} ${time}`, `${this.time_zone_name}`).utc().format('HH:mm'),
          };
          data.push(item);
        }
      }
      return data;
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
  },
};
</script>

<style scoped>
* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .list__hours.v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin-bottom: 0;
  background: #cbcbcb;
  /* border: 2px solid #02a554; */
  padding: 8px 16px;
  border-radius: 23px;
}
* >>> .list__hours.v-input--selection-controls.v-input .v-label {
  color: #000000;
}
* >>> .list__hours.v-input--is-label-active .v-input__control .v-input__slot {
  background: #02a554;
}
/* * >>> .flatpickr-calendar,
* >>> .flatpickr-rContainer,
* >>> .flatpickr-days {
  width: 450px;
}
* >>> .flatpickr-day {
  max-width: 57px;
  height: 57px;
  line-height: 57px;
} */
/* * >>> .dayContainer {
  width: 450px;
  max-width: 450px;
} */
</style>
